import { render, staticRenderFns } from "./LightCheckout.vue?vue&type=template&id=b49c49b2&scoped=true&"
import script from "./LightCheckout.vue?vue&type=script&lang=js&"
export * from "./LightCheckout.vue?vue&type=script&lang=js&"
import style0 from "./LightCheckout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LightCheckout.vue?vue&type=style&index=1&id=b49c49b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49c49b2",
  null
  
)

export default component.exports